<template>
  <component :is="currentDevice" class="flex-full" />
</template>

<script>
import InstructionIphonePage from '../components/theme/blocks/Instruction/Iphone';
import InstructionAndroidPage from '../components/theme/blocks/Instruction/Android';

export default {
  name: 'Instruction',
  components: {
    InstructionIphonePage,
    InstructionAndroidPage
  },
  computed: {
    currentDevice () {
      if (this.$route.params.type === 'iphone') {
        return 'InstructionIphonePage'
      } else if (this.$route.params.type === 'android') {
        return 'InstructionAndroidPage'
      }
    }
  }
}
</script>
